/*
 * jQuery.bxPlayer.js
 * 
 * @author: wangzhenhua@cntv.cn
 */
(function($) {
    
    $.fn.bxPlayer = function(options, callback) {
        
        // Default Settings.
        var defaults = {
            id: '',
            item_id: '',
            pid: '100',
            width: 640,
            height: 385,
            poster: undefined,
            type: 'out',
            order: 'asc',
            autoplay: false,
            controls: false,
            callback: false
        };
        
        // Cached jQuery Object Variables
        var $base = this;
        var $video;
        
        // Variables for cached values or use across multiple functions
        var stats = [],
        videoData = null,
        videoList = null,
        nextAutoPlay = true,
        chapterURLs = [], 
        currentIndex = 0, 
        currentVideoId = '', 
        playEnded = false;
        
        var htmlTemplate = '<embed src="http://player.xiyou.cntv.cn/{id}.swf" quality="high" width="640" height="385" align="middle" allowScriptAccess="always" allowFullScreen="true" mode="transparent" type="application/x-shockwave-flash"></embed>';
        var flashTemplate = 'http://player.xiyou.cntv.cn/{id}.1.swf';
        
        // build main options before element iteration      
        options = $.extend(defaults, options);
        
        if (callback) {
            options.callback = callback;
        }
        
        // PUBLIC FUNCTIONS
        this.init = function() {
            //create html structure
            $video = $('<video' + ' webkit-playsinline playsinline' + (options.autoplay == true ? ' autoplay="true"' : ' preload="auto"') + (options.controls == true ? ' controls="true"' : '') + ' width="' + options.width + '" height="' +  options.height + '"></video>')
                    .appendTo(this);
            
            loadVideoInfo(options.id);
            
            $video.bind('ended', function() {
                if (currentIndex < chapterURLs.length - 1) {
                    currentIndex ++;
                    setVideoSource(true);
                } else {
                    if (isPlaylist() && nextAutoPlay == true) {
                        var index = getVideoPosition(currentVideoId) + 1;
                        if (index < videoList.length && videoList[index]) {
                            // play next video
                            options.autoplay = true;
                            loadVideoInfo(videoList[index]);
                            return ;
                        }
                    }
                    playEnded = true;                      
                    if (options.callback && $.isFunction(options.callback)) {
                        options.callback.call($video);
                    }                   
                }
            });
        };
        
        this.play = function() {
            $video[0].play();
        }; 
        
        this.pause = function() {  
            $video[0].pause();
        }; 
        
        // get video data
        this.getData = function() {
            return videoData;
        };
        
        // get video stat
        this.getStats = function() {
            return stats;
        };
        
        // get video list
        this.getPlaylist = function() {
            return videoList;
        };
        
        // change video
        this.changeVideo = function(id) {
            loadVideoInfo(id);
        };

        // set list autoplay
        this.setListAutoPlay = function(bool) {
            nextAutoPlay = bool;
        };
        
        // get current video id
        this.getVideoId = function() {
            return currentVideoId;
        };
        
        // get current video id
        this.resize = function(width, height) {
            return $video.attr({'width': height, 'height': height});
        };
        
        // PRIVATE FUNCTIONS    
        function isPlaylist() {
            return (options.type == 'playlist' || options.type == 'album' || options.type == 'my') ? true : false;
        }
        
        function loadVideoInfo(vid) {
            // reset data
            chapterURLs = []; currentIndex = 0; playEnded = false;
            videoData = null; stats = [];
            // 接口
            var hostUrl = document.location.href;
            var domainName = 'http://';
            if(hostUrl.split(':')[0] == 'https'){
              domainName = 'https://'
            }else{
              domainName = 'http://'
            }
            $.getScript(domainName + 'api.ishow.cctv.com/video/playAddress?varname=_xyVideoData_&showpath=1&pid=' + options.pid + '&videoId=' + vid + (isPlaylist() ? '&album=' + options.item_id : ''), function() {

            // $.getScript('http://xiyou.cctv.com/interface/index?varname=_xyVideoData_&showpath=1&pid=' + options.pid + '&videoId=' + vid + (isPlaylist() ? '&album=' + options.item_id : ''), function() {
      
                if (_xyVideoData_.status !== 'success') {
                    return errCode(4001, '获取视频信息失败');
                }
                videoData = _xyVideoData_.data[0];
                _xyVideoData_ = null;

                // Wraiting
                loadWraiting(options.type, currentVideoId, (videoData.outer_code ? videoData.outer_code : videoData.inner_code), videoData.timeSpan);
                
                currentVideoId = videoData.videoId;

                //if (supportM3U8() == false) {
                    if( "undefined" == typeof(videoData.videoList) && "undefined" != typeof(videoData.videoListHD)){
                        videoData.videoList = videoData.videoListHD;
                    }
                    for (var i = 0; i < videoData.videoList.length; i++) {
                        if (videoData.videoList[i].url != null && videoData.videoList[i].duration > 0) {
                            chapterURLs.push(videoData.videoList[i].url);
                        }
                    }

                    if (chapterURLs.length == 0) {
                        return errCode(4003, '获取视频地址失败');
                    } 

                    // 播放视频
                    setVideoSource(options.autoplay);
                    
                //} else {
                //    $.getScript('http://vdn.apps.cntv.cn/api/getIpadVideoInfo.do?pid='+ videoData.playid +'&tai=xiyou&from=html5', function() {
                //        if( "undefined" != typeof(html5VideoData.hls_url) && html5VideoData.hls_url.length > 0){
				//			if(html5VideoData.hls_url.indexOf("?") !== -1){
				//				html5VideoData.hls_url += "&minbr=400";
				//			} else{
				//				html5VideoData.hls_url += "?minbr=400";
				//			}
                //            chapterURLs.push(html5VideoData.hls_url);
                //        } else {
				//			if(html5VideoData.video.chapters)
				//			{
				//				for (var i = 0; i < html5VideoData.video.chapters.length; i++) {
				//				if (html5VideoData.video.chapters[i].url != null && html5VideoData.video.chapters[i].duration > 0) {
				//						chapterURLs.push(html5VideoData.video.chapters[i].url);
				//					}
				//				}
				//			}
                //        }
                //
                //        if (chapterURLs.length == 0) {
                //            return errCode(4003, '获取视频地址失败');
                //        } 
                //
                //        // 播放视频
                //        setVideoSource(options.autoplay);
                //    });
                //}         
                
                
                
                // refresh web
                if (typeof(refreshWebPage) != 'undefined' && $.isFunction(refreshWebPage)) {
                    refreshWebPage(currentVideoId, 'next');
                }
                    
                // 格式化数据
                videoData.time = gTimeFormat(videoData.timeSpan);
                videoData.refHtml = htmlTemplate.replace('{id}', currentVideoId);
                videoData.refFlash = flashTemplate.replace('{id}', currentVideoId);
                videoData.videoList = null;
                
           /*     if (isPlaylist() && videoList == null) {
                    $.getScript('http://xiyou.cctv.com/interface/relative?varname=_xyRelData_&item_type=' + (options.type == 'my' ? 'program' : options.type) + '&item_id=' + options.item_id + '&order=' + options.order, function() {
                        if (_xyRelData_.status !== 'success') {
                            return errCode(4004, '获取视频列表失败');
                        }
                        videoList = _xyRelData_.data;
                        _xyRelData_ = null;
                        return false;
                    }); 
                }*/
                return errCode(200, 'OK');
            });
        }
        
        function loadWraiting(type, vid, code, time) {
            var wratingUrl = 'http://cntv.wrating.com/v.gif?s=&ut=&t=&j=&f=&c={CODE}&l=&b={URL}&js=&a=&ck=&n=&st=A-1_3|3_1|-2_0&vlen={TIME}&z=&i=&vu={URL}&vid={CODE}';
            
            wratingUrl = wratingUrl.replace('{CODE}', code);
            wratingUrl = wratingUrl.replace('{CODE}', code);
            wratingUrl = wratingUrl.replace('{URL}', getVideoPageURL(vid));
            wratingUrl = wratingUrl.replace('{URL}', getVideoPageURL(vid));
            wratingUrl = wratingUrl.replace('{TIME}', time);
            $.getScript(wratingUrl);

            return;
        }
        
        function getVideoPageURL(vid) {
            var videoPageTemplate = 'http://xiyou.cctv.com/v-{id}.html';
            return encodeURIComponent(videoPageTemplate.replace('{id}', vid));
        }
        
        function setVideoSource(autoplay) {
            $video[0].pause();
            $video.attr('poster', options.poster ? options.poster : videoData.imagePath);
            $video.attr('src', chapterURLs[currentIndex]);
            if (autoplay) {
                $video[0].load();
                $video[0].play();
            };
        }
        
        function gTimeFormat (seconds) {
            var m = Math.floor(seconds/60) < 10 ? "0" + Math.floor(seconds/60) : Math.floor(seconds/60);
            var s = Math.floor(seconds-(m*60)) < 10 ? "0" + Math.floor(seconds-(m*60)) : Math.floor(seconds-(m*60));
            return m + ':' + s;
        }
        
        
        function getVideoPosition (id) {
            var len = videoList.length;
            for (var i = 0; i < len; i++) {
                if (id == videoList[i]) {
                    return i;
                    break;
                }
            }
            return -1;
        }
        
        function errCode  (c, m) {
            stats = {code: c, msg: m};
            return stats;
        }

        function supportM3U8() {
            if (/(iphone|ipad|ipod|ios)/i.test(navigator.userAgent))
                return true;

            if (/(firefox)/i.test(navigator.userAgent))
                return false;

            var version = 0;
            var clientInfo = navigator.userAgent.toLowerCase();
            var pos = clientInfo.indexOf("android");
            version = clientInfo.substr(pos+7);
            version = parseFloat(version);
            if(!version) {
                version = clientInfo.substr(pos+8);
                version = parseFloat(version);
            }
            return version > 4.1;
        }
        
        // iterate and reformat each matched element
        return this.each(function() {
            $base.init();
        });
        
        return this;
    };
    
})(jQuery);


var html5VideoData;
function getHtml5VideoData(data)
{
    html5VideoData = eval('(' + data + ')');;
}



//////////////////
// WEBPACK FOOTER
// ./static/lib/jquery.bxPlayer.js
// module id = SldU
// module chunks = 0